import React from 'react';
import styled from "styled-components"
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BannerContainer, BannerContainerMobile, boxStyles } from "./style"
import Grid from '@mui/material/Grid';
import MinhaImagem from './Advocacia_banner.png';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom'; 
import Botao from "../../../components/Botao";



const ImagemEstilizada = styled.img`


  // Adicione mais estilos conforme necessário
  width: 500px;
  height: 300px;
  margin-left: 30px; 

  @media (max-width: 768px) {
    width: 95%;
  height: 250px;
  margin-left: 15px; 
  margin-top: 7px;
  }

  @media (max-width: 430px) {
    width: 95%;
  height: 250px;
  margin-left: 10px; 
  margin-top: 7px;
  }
`;


const BoxDiv = styled.div`


  // Adicione mais estilos conforme necessário
  width: 600px;
  color: white;
  max-width: 550;

  @media (max-width: 768px) {
    width: 350px;
    margin-left: 30px;
    margin-top: 0px;
  color: white;
  max-width: 555;
  }

  @media (max-width: 375px) {
    width: 350px;
    margin-left: 10px;
    margin-top: 83px;
  color: white;
  max-width: 555;
    
  }
`;





const Banner = () => {
  const navigate = useNavigate(); // Hook do React Router para navegação

  const handleButtonClick = () => {
    navigate('/solicite-proposta'); // Altere para o caminho correto da sua rota
  };
  return (
    <BannerContainer>
      <BoxDiv>
        <br></br>
        <Typography variant="h2" gutterBottom>
          Precisando de ajuda  com problemas jurídicos?
        </Typography>
        <Typography variant="h6" gutterBottom>
        Questões jurídicas podem atrapalhar muito sua vida, seu patrimônio e seus negócios. Por isso, estamos aqui para ajudar.
        </Typography>
        <Botao
         texto='Seja Nosso Cliente'
         corFundo="#ff916e"
         corHover="#09af19"
        onClick={handleButtonClick}
      
          />
      </BoxDiv>

      <ImagemEstilizada src={MinhaImagem} alt="Descrição da Imagem"  />

      

    </BannerContainer>
  );
};

export default Banner;